export default "__VITE_ASSET__961870a6__"